<script lang="ts" setup>
import { ChevronLeft } from 'lucide-vue-next'
import { useTranslateKey } from '@/lib/utils'
import type { NavItems } from './sidebarConfig'

interface Props {
  show: boolean
  activeRoute: NavItems | null
}

defineProps<Props>()

const emit = defineEmits<{
  navigate: [navItem: NavItems]
  back: []
}>()

const { translateKey } = useTranslateKey()

const handleNavigate = (navItem: NavItems) => {
  emit('navigate', navItem)
}

const handleBack = () => {
  emit('back')
}
</script>

<template>
  <div
    class="bg-background border-border absolute left-[400px] h-full overflow-y-auto border-l pt-16 text-nowrap transition-all duration-300"
    :class="{
      'border-border w-[400px] border-r px-6 opacity-100 max-[800px]:left-0': show,
      'm-0 w-0 p-0 max-[800px]:-left-400': !show
    }"
  >
    <div
      class="text-primary hover:text-primary/80 absolute top-4 flex cursor-pointer items-center transition-colors"
      @click="handleBack"
    >
      <ChevronLeft class="text-primary primary size-4" />
    </div>
    <div class="flex flex-col gap-5">
      <template v-for="subroute in activeRoute?.subroutes" :key="subroute.label">
        <div
          class="group flex w-fit cursor-pointer items-center gap-2"
          @click="handleNavigate(subroute)"
        >
          <h1 class="font-panama-regular relative">
            {{ translateKey(subroute.label) }}
            <div
              class="bg-primary absolute -bottom-1 left-0 h-0.25 w-0 transition-all duration-300 ease-out group-hover:w-full"
            />
          </h1>
        </div>
      </template>
    </div>
  </div>
</template>
